import { createSlice, nanoid, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import {
  INotification,
  INotificationsState,
  IStoredNotification,
} from "./definitions";

const initialState: INotificationsState = {
  items: [],
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    notificationAdded: {
      prepare: (payload: INotification) => ({
        payload: { ...payload, id: payload.id || nanoid() },
      }),
      reducer: (state, action: PayloadAction<IStoredNotification>) => {
        const { id } = action.payload;
        if (state.items.some((item) => item.id === id)) return;
        state.items.push(action.payload);
      },
    },
    notificationDismissed: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    notificationsCleared: (state) => {
      state.items = [];
    },
  },
});

export const {
  notificationAdded,
  notificationDismissed,
  notificationsCleared,
} = notificationsSlice.actions;

export const selectNotifications = (state: RootState) => state.notifications;

export default notificationsSlice.reducer;
